import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { useClientRenderDelay } from 'utils/hooks/useClientRenderDelay';
import styles from '../../../migration/components/MigrationPanel/migrationpanel.module.css';
import { ASIAccordion } from 'structure/migration/components/MigrationPanel/ASITokenMigrationDisclaimer';

export const ASITokenClaimsDisclaimer = () => {
  const { t } = useTranslation('claim');
  const csr = useClientRenderDelay();

  return (
    <div className={cx(twMerge(styles.migrateBubbles), 'ml-0')}>
      <h2
        className={cx(
          twMerge(
            styles.migrateFont,
            'mb-6 mt-4 text-xl font-bold text-white md:mt-0'
          )
        )}
      >
        {t('SINGULARITY_FINANCE_TESTNET_REWARDS')}
      </h2>
      {csr && (
        <>
          <ASIAccordion
            disc={false}
            expanded={true}
            lists={[t('DETAILS_DESCRIPTION')]}
            title={t('DETAILS')}
          />
          <ASIAccordion
            expanded={true}
            disc={false}
            lists={[t('ASI_CLAIM_DISCLAIMER')]}
            title={t('DISCLAIMER')}
          />
        </>
      )}
    </div>
  );
};
